<template>
  <div class="page" v-wechat-title="$route.meta.title">
    <!--<div class="link-btn" @click="goHome">首页</div>-->

    <!--关注-->
    <div class="focus" v-if="res.isfocushint==1&&(res.isfocus==0||res.isfocus==null)">
      <img class="icon-focus" :src="focusRes.isconfig==6?focusRes.focusimg:require('../../assets/icon-focus.png')" alt="">
      <span class="focus-txt hide">{{focusRes.isconfig==6?focusRes.focusinfo:'关注金牌解说&nbsp;&nbsp;收听更多景区讲解'}}</span>
      <span class="focus-btn" @click="focusFun()" v-if="isNaN(parseInt((focusRes.focusinfo).replace(/[^0-9]/ig,'')))">关注</span>
      <a class="focus-btn" :href="'tel:' + parseInt((focusRes.focusinfo).replace(/[^0-9]/ig,''))" v-else>拨号</a>
    </div>

    <!--轮播图-->
    <div class="swiper-con border-box" @click="goWaterfallLz()">
      <img class="img" v-lazy="shop.logo" alt="">
      <span class="img-num"><i>1</i>/{{res.imgCount}}</span>
    </div>

    <div class="shop-tit">
      <h3>{{shop.name}}</h3>
      <p>临展时间：{{shop.routetime}}</p>
    </div>

    <div class="voice-list">
      <div class="voice-li border-box" v-for="(item,index) in bagList" :key="index" @click="goVideoPlay(index)">
        <div class="list-top box">
          <div class="list-img">
            <!--<img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="" @click.stop="goGuideInfo(item.id)">-->
            <img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="">
            <!--头像底部语音播放 -->
            <div class="listen-btn-num" v-if="item.buy==12||item.price==0||item.isuser">
              <img src="../../assets/icon-listen.png" alt="">
              <span>收听</span>
            </div>
            <div class="listen-btn-num" @click.stop="listenTurlClick(index)" v-else>
              <img :src="item.isplay==1?require('../../assets/icon_listen02.gif'):require('../../assets/icon-listen.png')" alt="">
              <span>{{item.isplay==1?item.resTime+"'":"试听"}}</span>
            </div>
          </div>
          <div class="flex list-info">
            <h3 class="list-group hide">{{item.name}}</h3>
            <p class="list-name hide">{{item.guidename2?item.guidename2:item.guidename}}<span v-if="item.guidetag">/{{item.guidetag}}</span></p>
            <!--新增星级评分-->
            <div class="list-star clearfix">
              <template v-for="(star,index) in [2,4,6,8,10]">
                <img v-if="item.hotlevel>=star" src="../../assets/star_curr1.png"/>
                <img v-else  src="../../assets/star_nor1.png" />
              </template>
              <span>{{item.hotlevel}}</span>
            </div>

            <div class="list-sees clearfix">
              <img src="../../assets/icon-label-sees.png" alt="">包含{{item.sees}}个讲解点
            </div>
            <span class="list-btn" @click.stop="goVideoPlay(index)" v-if="(item.buy==12)||(item.isuser)||(item.price==0&&res.noReward==1)">收听</span>
            <span class="list-btn" @click.stop="goVideoPlay(index,'rewardShow')" v-else-if="item.price==0">打赏</span>
            <span class="list-btn" @click.stop="buyVideo(index)" v-else>{{item.price}}元</span>
          </div>
        </div>
        <div class="list-bottom box">
          <p class="flex tl"><img src="../../assets/icon_31_2.png" />
            {{item.comments|initNumber}}人评论</p>
          <p class="flex tc"><img src="../../assets/icon-label-listen_01.png" />
            {{item.comments|initNumber}}人收听</p>
          <p class="flex tr"><img src="../../assets/icon_play_btn09_2.png" />
            {{item.buynum|initNumber}}人购买</p>
        </div>
      </div>
    </div>

    <div class="shop-info" v-if="shop.content">
      <h3>展览简介</h3>
      <div v-html="shop.content"></div>
    </div>

    <!--试听结束弹窗新版-->
    <AlertListenEnd  :bag="bag" :couponid="couponid" :extral="extral" :bagtype="'lz'" :shopid="shopid" @close="closeEnd" v-if="Object.keys(bag).length>0"></AlertListenEnd>

    <!--提醒用户购买弹窗弹窗-->
    <AlertPayTip @close="closePayTip" :comeForm="0" v-if="buyTip==1"></AlertPayTip>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>

    <!--关注公众号弹窗-->
    <Focus :focusRes="focusRes" v-on:alert-Focus="closeFocus()" v-if="focusEwmShow==1"></Focus>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import Swiper from '../../components/Swiper'
  import {pavilionDetail, uploadScan, uploadUserBrowse, getNotice} from "@/service/getData";
  import {wxGetPosition,wxShareme,listenEndOrder, listenTurl} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import AlertListenEnd from '../../components/AlertListenEnd'
  import AlertPayTip from '../../components/AlertPayTip'
  import Focus from '../../components/Focus'
  import P400 from '../../components/P400'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        code: this.$route.query.code || '', //城市站点id
        siteid:'',//站点id
        sregion:'',//省站点id:430000
        qrcode: '', //是否是扫码
        qid: '', //扫码id
        shopid: '', //景区id
        spotid: '', //景点id
        userInfo: {}, //用户信息
        page: 1,
        rows: 10,
        res: "", //全部数据
        bagList: [],//解说列表
        shop: '',//景区信息
        routes: '',//游玩路线
        buyTip: 0, //购买提醒弹窗

        Audio: '', //音频dom
        videoTimer: null, //语音播放计时器
        currIndex: -1, //当前播放音频数组下标
        index1: 0, //当前播放音频数组下标(用来记录currIndex，传值给下订单方法)
        bag:{}, //当前试听的专辑
        extral:{}, //存放下单需要的值
        couponid: '', //优惠券id

        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',

        focusEwmShow:0,//二维码弹窗0：隐藏   1：显示
        focusRes:'',//二维码弹窗数据

        P400: 0, //系统维护中
        PSV: null, //全景图片
        loadPSV: false, //全景是否加载完
      }
    },
    computed: {

    },

    beforeRouteLeave (to, from, next) {
      if(to.path.indexOf('waterfall-lz') > -1){
        from.meta.keepAlive = true;
      }else {
        from.meta.keepAlive = false;
      }
      console.log(to);
      console.log(from);
      next();
    },
    created(){
      this.$loading.show('数据加载中');
      this.shopid = this.$route.query.shopid;
      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }
      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }
      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }
      this.initData(this.page);

      this.qrcode = this.$route.query.qrcode;
      this.qid = this.$route.query.qid;
      if(this.qid){
        setStore("qid", {"qid":this.qid});
      }
      if(this.qrcode){
        let self = this;
        wxGetPosition(function(res){
          self.sendScan(res.latitude,res.longitude);
        });
      }

      this.getBuyNotice();

    },
    beforeDestroy(){
      if(this.videoTimer){
        clearInterval(this.videoTimer);
        this.currIndex = -1;
        this.bagList[this.index1].isplay = 0;
        this.bag = {};
      }
    },
    methods: {

      //获取语音+景区+推荐信息
      async initData(page){
        let res = await pavilionDetail({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          page: page,
          rows: this.rows,
          shopid: this.shopid
        });

        if (res.errcode === "00000"){
          this.$loading.hide();

          this.res = res.data;
          this.focusRes = res.data;
          this.shop = res.data.shop;


          for(var i=0; i<res.data.root.length; i++){
            res.data.root[i].isplay = 0;
            res.data.root[i].toaTime = '';
            res.data.root[i].resTime = '';
          }
          this.bagList = res.data.root;

          var share = res.data.share;
          let link = '/view-detail-lz?shopid='+ this.shopid +'&siteid='+ this.siteid + '&sregion='+ this.sregion  +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          if(share == null){
            let title = '金牌解说 | ' + this.shop.name;
            let desc = '历史会说话！金牌解说为您讲解' + this.shop.name + '的历史故事';
            let img = this.shop.logo;
            wxShareme(title,desc,img,link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }

          this.$route.meta.title = this.shop.name;

        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }

      },

      //提醒用户购买弹窗
      async getBuyNotice(){
        let res = await getNotice({
          TimeStamp: this.TimeStamp,
          openId: this.userInfo.openid
        });
        if (res.errcode === "00000"){
          this.buyTip = 1;
        }
      },

      //上传扫码数据
      async sendScan(lat,lng){
        let res = await uploadScan({
          openid: this.userInfo.openid,
          shopid: this.shopid,
          qid: this.qid || "",
          lat: lat || "",
          lng: lng || ""
        });
      },

      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await uploadUserBrowse({
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      //点击试听，调用试听公用方法
      listenTurlClick(ind){
        MtaH5.clickStat('view_detail_listen');
        MtaH5.clickStat('xiangqingyeshit',{'viewdetaillisten':'true'});//景区、景点》1试听弹窗》购买》支付
        MtaH5.clickStat('jingqujingdiana-1',{'1listen':'true'});//景区景点1试听》直接购买》支付

        listenTurl(this,ind,this.bagList)
      },

      //点击购买，调用下订单公用方法
      buyVideo(ind){
        MtaH5.clickStat("view_detail_buy");
        MtaH5.clickStat('zhuanjixiangqin',{'choose':'true'});//专辑详情页点击推荐景区》1购买》支付
        MtaH5.clickStat('viewspotbuy',{'1viewspotbuy':'true'});//景区景点直接点击1购买》支付
        MtaH5.clickStat('jingqujingdiana-1',{'2buy':'true'});//景区景点试听》1直接购买》支付
        let list = this.bagList[ind] ;
        let self = this;

        setStore("source", {"source": "index"})
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+list.id+'&cid='+self.couponid+'&shopid='+self.shopid+'&bagtype=lz'+'&appKey='+(self.appKey)}`
        });
      },

      //关闭试听弹窗，购买成功修改音频状态
      closeEnd(msg){
        this.bag = msg.bag;
        if(msg.isbuy){
          this.bagList[this.index1].buy = 12;
        }
      },

      //关闭购买提醒弹窗
      closePayTip(msg){
        this.buyTip = msg;
      },

      //跳转到专辑详情页
      goVideoPlay(ind,rewardShow){
        MtaH5.clickStat('jingqujingdiana-2',{'1tovideo':'true'});//景区景点1进入专辑详情》点击购买》支付
        MtaH5.clickStat('jingqujingdiana-3',{'1tovideo':'true'});//景区景点1进入专辑详情》试听》购买》支付
        MtaH5.clickStat('jingqujingdiana-4',{'1tovideo':'true'});//景区景点1进入专辑详情》试听》弹窗购买》支付

        let list = this.bagList ;
        if(rewardShow){
          this.$router.push({
            path: `/video-play-lz?${'id='+list[ind].id+'&spotid='+list[ind].spotid+'&shopid='+this.shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&rewardShow=1'}`
          });
        }else {
          if((list[ind].buy!=12)&&(!list[ind].isuser)){
            MtaH5.clickStat('list_detail_button')
          }
          this.$router.push({
            path: `/video-play-lz?${'id='+list[ind].id+'&spotid='+list[ind].spotid+'&shopid='+this.shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
          });
        }
      },

      //跳转到导游详情页
      goGuideInfo(id){
        MtaH5.clickStat("view_detail_person");
        MtaH5.clickStat('jingqujingdiana',{'1guide':'true'});//景区景点1点击导游头像》个人主页购买》支付
        this.$router.push({
          path: `/guide-info?${'id='+ id + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      },

      //跳转到图片瀑布流页面
      goWaterfallLz(){
        this.$router.push({
          path: `/waterfall-lz?${'shopid='+ this.shopid}`
        });
      },

      //跳转到首页
      goHome(){
        if(this.code){
          this.$router.push({
            path: `/city-site?${'code='+ this.code + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }else {
          MtaH5.clickStat("view_to_home");//景区详情页面点击跳转首页
          this.$router.push({
            path: `/?${'siteid='+ this.siteid + '&sregion='+ this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }
      },

      //关注公众号
      focusFun(){
        MtaH5.clickStat("focus");//关注公众号
        this.focusEwmShow = 1;
      },

      //公众号弹窗关闭
      closeFocus(){
        this.focusEwmShow = 0;
      },

    },
    watch:  {
      bag(newVal,oldVal){
        if(Object.keys(newVal).length){
          let list = this.bagList ;
          listenEndOrder(this,this.index1,list);
        }
      },
      VRlist(){
        var self = this;
        this.$nextTick(function(){
          if(self.VRlist[0].vrimg && self.VRlist[0].vrimg != '' && self.VRlist[0].vrimg != null){
            self.showPhotoVR(self.VRlist[0].vrimg,'video-vr-img');
          }
        })
      },
    },
    components: {
      Swiper,
      AlertListenEnd,
      AlertPayTip,
      Focus,
      P400
    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  /*@import "../../style/voice.css";*/

  .page{position: relative; min-height: 100vh;  background: #1a1a1a url(../../assets/video-bg2.png) repeat; }

  /*关注*/
  .focus{width:100%;height: .75rem;background: rgba(0,0,0,.8);color: #fff;}
  .icon-focus{float: left;width: auto;height: .52rem;margin:.115rem .22rem 0 .27rem; }
  .focus-txt{float: left;width:63%;font: .24rem/.75rem "Microsoft YaHei";letter-spacing: .02rem; }
  .focus-btn{float: right;width:1.15rem;height: .5rem;margin-top:.125rem;margin-right:.1rem;border: 1px solid #ffac56;color: #fff;font: .24rem/.5rem "Microsoft YaHei";
    text-align: center;border-radius: .3rem;-webkit-animation: focus 1.2s linear infinite;animation: focus 1.2s linear infinite;-webkit-transform: scale(.96);transform: scale(.96);}
  @-webkit-keyframes focus {0%{-webkit-transform: scale(.96);}20%{-webkit-transform: scale(1);}40%{-webkit-transform: scale(.96);}60%{-webkit-transform: scale(1);}80%{-webkit-transform: scale(.96);}100%{-webkit-transform: scale(1);}}
  @keyframes focus {0%{transform: scale(.96);}20%{transform: scale(1);}40%{transform: scale(.96);}60%{transform: scale(1);}80%{transform: scale(.96);}100%{transform: scale(1);}}

  /*轮播图内跳转首页按钮*/
  .link-btn{position: fixed;z-index:2;right:0;top: 2rem;height: .6rem;padding:0 .28rem;font: .28rem/.6rem "Microsoft YaHei";color:#fff;border-radius: .3rem 0 0 .3rem;background: rgba(0,0,0,.7);}

  .swiper-con{ position: relative; width:100%;height: 3.8rem;}
  .swiper-con > .img{ background: url(../../assets/loadimg.png) no-repeat center; background-size: 35% auto; }
  .img-num{ position: absolute; right: .16rem; bottom: .16rem; z-index: 1; width: 1.08rem; height: .44rem; line-height: .44rem; font-size: .22rem; color: #fff; text-align: center; border-radius: .44rem; background: rgba(0,0,0,.4); }
  .img-num i{ font-size: .28rem; font-style: normal;}

  .shop-tit{ padding: .3rem .22rem 0; }
  .shop-tit > h3{ font-weight: normal; font-size: .36rem; color: #f6a931; }
  .shop-tit > p{ margin-top: .17rem; font-size: .24rem; color: #999;}

  .voice-list{ padding: .08rem .22rem 0; }
  .voice-li{ position: relative;background: #1a1a1a url(../../assets/video-bg3.png) repeat;margin-top: .22rem;border-radius: .1rem;padding: .26rem .23rem;box-shadow: 0 0 0.25rem #000; }
  .list-top{ padding-bottom: .24rem; height: 2.28rem; border-bottom: 1px solid #111; }
  .list-img{ position: relative; width: 2.15rem; height: 2.28rem; border-radius: .13rem; overflow: hidden;}
  .list-img img.icon-tx{display:block;width:100%;height:100%;background-color: #1a1a1a;object-fit: cover;background: url(../../assets/loadimg.png) no-repeat center; background-size: 80% auto;}
  .listen-btn-num {position: absolute;left:50%;bottom:.25rem;width:1.5rem;height:.56rem;line-height:.56rem;background:rgba(0,0,0,.5);border-radius:.30rem;transform:translateX(-50%);text-align:center;z-index:1;}
  .listen-btn-num img {width:auto;height: .28rem;margin-top: .14rem;margin-right:.09rem;vertical-align:top;}
  .listen-btn-num span {height:.56rem;line-height:.56rem;font-size:.22rem;color:#fffefe;font-weight:bold;vertical-align:top;}
  .list-info{position:relative;padding-left: .25rem; }
  .list-group{ margin-top: .24rem; font-size:.32rem;color:#f6a931;}
  .list-name{margin-top: .18rem;font-size: .22rem;color: #999;}
  .list-star{height:.42rem;margin-top: .15rem;}
  .list-star img{float:left;width: auto;height: .25rem;margin-right: .09rem;margin-top: .085rem;}
  .list-star span{float: left;margin-left:.08rem;font: .24rem/.42rem "Microsoft YaHei";color: #666;}
  .list-sees{ margin-top: .12rem; height: .25rem; line-height: .25rem; font-size: .22rem; color: #666;}
  .list-sees img{ height: .25rem; margin-right: .1rem; vertical-align: text-bottom; }
  .list-btn{ position: absolute; right: 0; bottom: .32rem; z-index: 1; width: 1.18rem; height: .52rem; line-height: .52rem; font-size: .28rem; font-weight: bold; color: #f6a931; text-align: center; border: 1px solid #f6a931; border-radius: .54rem; }
  .list-bottom{ padding-top: .32rem; height: .32rem; line-height: .32rem; font-size: .24rem; color: #666; }
  .list-bottom img{ height: .32rem; margin-right: .03rem; vertical-align: text-bottom; }
  .list-bottom .fl img{ vertical-align: middle; }
  .list-bottom .tr img{ height: .3rem; }

  .shop-info{ padding: .35rem .22rem 0; }
  .shop-info > h3{ font-size: .36rem; color: #f6a931; }
  .shop-info > div{ margin-top: .15rem; font-size: .28rem; line-height: .48rem; color: #999; }


</style>



// WEBPACK FOOTER //
// src/page/view-detail/view-detail-lz.vue